import styled from 'styled-components';

const AdjustmentDataResultStyled = styled.div`
  margin-top: 4px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  flex-grow: 1;
  div {
    border-radius: 10px;
    .table-content,
    .commentBox {
      border-radius: 5px;
    }
    .page-size .select {
      border-radius: 4px;
    }
  }
  .icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    fill: #1565c0;
  }
  .suspend {
    width: 45px;
    height: 35px;
  }
`;

export default AdjustmentDataResultStyled;
